// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../node_modules/css-loader/dist/cjs.js??ref--7-oneOf-3-1!../node_modules/postcss-loader/src/index.js??ref--7-oneOf-3-2!../node_modules/postcss-loader/src/index.js??ref--7-oneOf-3-3!vue-context/dist/css/vue-context.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "ol,ul{list-style:none;margin:0;padding:0}", ""]);
// Exports
module.exports = exports;
